// extracted by mini-css-extract-plugin
module.exports = {"ServiceDetails":"HYncG","ServiceMetricsContainer":"_39PAI","QuestionsAnswers":"cGBf6"};